import ContentModal from "./content-modal.component";

export default ContentModal;
